export class LandingPage {
    constructor({
                    //attributes
                    id= null,
                    name= '',
                    model_production= null,
                    model_edition= null,
                    company_id = null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    layouts= {},
                    popup= {},
                    campaign_id= null,
                    deleted_at= null,
                    send_type= null,
                    template_id= null,
                    messages_active= null
                    //relations
                } = {}) {

        //fill attributes

        this.id= id;
        this.name=name;
        this.model_production=model_production;
        this.model_edition=model_edition;
        this.company_id=company_id;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.layouts=layouts;
        this.popup=popup;
        this.campaign_id=campaign_id;
        this.deleted_at=deleted_at;
        this.send_type=send_type;
        this.template_id=template_id;
        this.messages_active=messages_active;

    }

}

export function createLandingPage(data={}) {
    return Object.freeze(new LandingPage(data));
}